<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#map-legend {
        position: absolute;
        z-index: 9;
        left: 0.5rem;
        bottom: 0.5rem;
        background: #FFFFFF;
        max-width: 220px;
        border-radius: 0.5rem;
        padding: 0.75rem;
        font-family: 'Raleway', sans-serif;
        box-shadow: 0 0 #000000, 0 0 #000000, 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1);

        span.legend-title {
            display: block;
            text-align: center;
            font-family: 'Raleway', sans-serif;
            margin-bottom: 10px;
            font-size: 16px;
            font-weight: bold;
        }

        div.legend-row {
            margin-bottom: 5px;
            font-size: 14px;

            img {
                margin-right: 10px;
            }
        }
    }
</style>

<template>
    <div id="map-legend" v-show="( !showFilters && servicesView == 'map' && workroom != 60 && workroom != 860 )">
        <div class="grid-x">
            <div class="large-12 medium-12 small-12 cell">
                <span class="legend-title">{{ $t('legend.label') }}</span>
            </div>
            <div v-if="showClientPreferenceLegend" class="large-12 medium-12 small-12 cell legend-row">
                <img src="/img/service-blue-marker.svg"/> {{ $t('legend.clientService') }}
            </div>
            <div class="large-12 medium-12 small-12 cell legend-row">
                <img src="/img/service-grass-green-marker.svg"/> {{ $t('legend.slotService') }}
            </div>
            <div class="large-12 medium-12 small-12 cell legend-row">
                <img src="/img/service-middle-orange-marker.svg"/> {{ $t('legend.normalService') }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showClientPreferenceLegend: false
            }
        },

        computed: {
            showFilters(){
                return this.$store.getters.getShowFilters;
            },

            servicesView() {
                return this.$store.getters.getServicesView;
            },

            workroom() {
                return this.$store.getters.getWorkroom;
            },

            services() {
                return this.$store.getters.getServices;
            }
        },

        watch: {
            services() {
                if (this.services.some(service => service.client_preference == 1)) {
                    this.showClientPreferenceLegend = true;
                } else {
                    this.showClientPreferenceLegend = false;
                }
            },
        }
    }
</script>
